import React, {FC} from 'react';
import {Pressable, View} from 'react-native';

import Carousel from '@/components/Carousel';
import StaticImage from '@/components/StaticImage';
import Text from '@/components/Text';
import {IMintOfferInfo} from '@/modules/Collect/types';
import {useThemedStyles} from '@/theme';
import {ITrack} from '@/types/common';
import {ImageSize} from '@/types/media';
import {getTrackArtistsNames} from '@/utils/tracks';

import {styles, IMAGE_SIZE} from './EditionPicker.style';

interface IProps {
  track: ITrack;
  onSelectOffer: (offerId: string) => void;
  selectedOffer: IMintOfferInfo;
  mintOffers: IMintOfferInfo[];
  disabled?: boolean;
}

const EditionPicker: FC<IProps> = ({
  track,
  onSelectOffer,
  selectedOffer,
  mintOffers,
  disabled = false,
}) => {
  const style = useThemedStyles(styles);

  return (
    <View style={style.container}>
      <View>
        <Carousel
          items={mintOffers}
          renderItem={offer => (
            <Pressable
              onPress={() => onSelectOffer(offer.id)}
              disabled={disabled}>
              <StaticImage
                style={style.editionItemImage}
                source={{
                  uri: track.lossyArtworkUrl,
                }}
                resizeWidth={ImageSize.track}
              />
            </Pressable>
          )}
          keyExtractor={offer => offer.id}
          onSelectItem={offer => onSelectOffer(offer.id)}
          activeKey={selectedOffer.id}
          itemWidth={IMAGE_SIZE}
          disabled={disabled}
        />

        {selectedOffer.metadata?.sound_tier && (
          <View style={style.editionName}>
            <Text size="xs">{selectedOffer.metadata?.sound_tier}</Text>
          </View>
        )}
      </View>

      <View style={style.trackInfo}>
        <Text weight="semibold" align="center">
          {track.title}
        </Text>
        <Text size="xs" align="center">
          {getTrackArtistsNames(track)}
        </Text>
      </View>
    </View>
  );
};

export default EditionPicker;
